import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { UserPermissionTypes, UserType } from '../../core/api/models';
import { useAuth } from '../../core/hooks';
import { cartResetAction, logoutAction, State } from '../../core/store';
import { isNullOrEmpty, translate } from '../../utils/text-utils';
import { RouteKeys } from '../routes/route-keys';
import './SideMenu.scss';
import noProfile from '../../assets/images/no-profile.png';
import { decodeHtmlEntities } from '../../utils/common';
import api from '../../api';

interface CustomProps {
  isExpand?: boolean;
  expandToggle: () => void;
  menuVisible?: boolean;
}

enum subMenus {
  payment = 'payment',
  settings = 'settings',
  salespersonSettings = 'salespersonsettings',
  schedule = 'schedule',
  reports = 'reports',
  sales = 'sales',
}

const SideMenu: React.FunctionComponent<CustomProps> = (props: CustomProps) => {
  const [subMenu, toggleSubMenu] = React.useState<subMenus | null>(null);
  const authState = useSelector((state: State) => state.authUser);
  const { hasRole, isSalesPerson, userToken } = useAuth();

  const subMenuSelection = (e: any, selected: subMenus) => {
    e.preventDefault();
    if (selected === subMenu) {
      toggleSubMenu(null);
    } else {
      toggleSubMenu(selected);
    }
  };
  const dispatch = useDispatch();
  const history = useHistory();
  React.useEffect(() => {
    if (!props.isExpand) {
      toggleSubMenu(null);
    }
  }, [props.isExpand]);
  const { pathname } = useLocation();
  const handleLogout = async () => {
    const currentUserToken = api.getUserToken();
    const response = await api.auth.logout(currentUserToken || '');
    dispatch(logoutAction());
    dispatch(cartResetAction());
    history.push(RouteKeys.Login);
  };
  return (
    <>
      <div
        className={`sidemenu bg-primary ${
          props.isExpand === true ? 'menuExpand' : ''
        } ${props.menuVisible === true ? 'menuVisible' : ''}`}
      >
        <div className="sidemenu-inner">
          <ul className="list-unstyled p-0 m-0 menu-list py-2">
            <li>
              <div className="py-3 mt-1">
                <div className="row flex-nowrap m-0">
                  <div className="col-auto profile-pic">
                    <img
                      src={
                        !isNullOrEmpty(authState?.profile?.userProfilePicture)
                          ? authState?.profile?.userProfilePicture
                          : noProfile
                      }
                      width="30"
                      height="30"
                      className="rounded-circle"
                      alt={authState?.profile?.name ?? ''}
                    />
                  </div>
                  <div className="col minw-0 pl-0">
                    <div className="line-height-normal text-nowrap px-px">
                      <h6 className="font-sm text-white m-0 text-truncate">
                        {decodeHtmlEntities(authState?.profile?.name ?? '')}
                      </h6>
                      <div className="font-xs text-white">
                        <div className="text-truncate">
                          {authState?.profile?.email ?? ''}
                        </div>
                      </div>
                      {/* <div>
                        <span
                          className="text-white font-xs cursor-pointer"
                          onClick={() => {
                            dispatch(logoutAction());
                            dispatch(cartResetAction());
                            history.push(RouteKeys.Login);
                          }}
                        >
                          {translate('sideMenu.logout')}
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </li>
            {/* {authState?.userType === UserType.Salesperson && (
              <li>
                <Link
                  to="/dashboard"
                  className={`d-flex align-items-center ${
                    pathname === '/dashboard' ? 'active' : ''
                  }`}
                >
                  <i className="icon-dashboard text-white"></i>
                  <span className="text-white">
                    {translate('sideMenu.dashboard')}
                  </span>
                </Link>
              </li>
            )} */}
            {userToken && (
              <li>
                <Link
                  to="/"
                  className={`d-flex align-items-center ${
                    pathname === '/' ? 'active' : ''
                  }`}
                >
                  <span className="menu-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M0.909091 8.7013C0.670996 8.7013 0.459957 8.60931 0.275974 8.42532C0.0919914 8.24134 0 8.0303 0 7.79221V0.909091C0 0.670996 0.0919914 0.459957 0.275974 0.275974C0.459957 0.0919914 0.670996 0 0.909091 0H7.79221C8.0303 0 8.24134 0.0919914 8.42532 0.275974C8.60931 0.459957 8.7013 0.670996 8.7013 0.909091V7.79221C8.7013 8.0303 8.60931 8.24134 8.42532 8.42532C8.24134 8.60931 8.0303 8.7013 7.79221 8.7013H0.909091ZM0.909091 20C0.670996 20 0.459957 19.908 0.275974 19.724C0.0919914 19.54 0 19.329 0 19.0909V12.2078C0 11.9697 0.0919914 11.7587 0.275974 11.5747C0.459957 11.3907 0.670996 11.2987 0.909091 11.2987H7.79221C8.0303 11.2987 8.24134 11.3907 8.42532 11.5747C8.60931 11.7587 8.7013 11.9697 8.7013 12.2078V19.0909C8.7013 19.329 8.60931 19.54 8.42532 19.724C8.24134 19.908 8.0303 20 7.79221 20H0.909091ZM12.2078 8.7013C11.9697 8.7013 11.7587 8.60931 11.5747 8.42532C11.3907 8.24134 11.2987 8.0303 11.2987 7.79221V0.909091C11.2987 0.670996 11.3907 0.459957 11.5747 0.275974C11.7587 0.0919914 11.9697 0 12.2078 0H19.0909C19.329 0 19.54 0.0919914 19.724 0.275974C19.908 0.459957 20 0.670996 20 0.909091V7.79221C20 8.0303 19.908 8.24134 19.724 8.42532C19.54 8.60931 19.329 8.7013 19.0909 8.7013H12.2078ZM12.2078 20C11.9697 20 11.7587 19.908 11.5747 19.724C11.3907 19.54 11.2987 19.329 11.2987 19.0909V12.2078C11.2987 11.9697 11.3907 11.7587 11.5747 11.5747C11.7587 11.3907 11.9697 11.2987 12.2078 11.2987H19.0909C19.329 11.2987 19.54 11.3907 19.724 11.5747C19.908 11.7587 20 11.9697 20 12.2078V19.0909C20 19.329 19.908 19.54 19.724 19.724C19.54 19.908 19.329 20 19.0909 20H12.2078ZM0.909091 7.79221H7.79221V0.909091H0.909091V7.79221ZM12.2078 7.79221H19.0909V0.909091H12.2078V7.79221ZM12.2078 19.0909H19.0909V12.2078H12.2078V19.0909ZM0.909091 19.0909H7.79221V12.2078H0.909091V19.0909Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  {authState?.userType === UserType.Salesperson
                    ? translate('others.customerDashboard')
                    : translate('sideMenu.catalog')}
                </Link>
              </li>
            )}
            {authState?.userType === UserType.Salesperson &&
              hasRole(UserPermissionTypes.place_order_for_customers) && (
                <li>
                  <Link
                    to="/customers"
                    className={`d-flex align-items-center ${
                      pathname === '/customers' ? 'active' : ''
                    }`}
                  >
                    <i className="icon-place-order1"></i>
                    {translate('sideMenu.placeOrder')}
                  </Link>
                </li>
              )}

            {hasRole(UserPermissionTypes.customer_orders) && (
              <li>
                <Link
                  to={'/orders'}
                  className={`d-flex align-items-center ${
                    pathname === '/orders' ? 'active' : ''
                  }`}
                >
                  <i className="icon-my_orders"></i>
                  {!isSalesPerson
                    ? translate('sideMenu.myOrders')
                    : translate('sideMenu.customerOrders')}
                </Link>
              </li>
            )}
            {hasRole(UserPermissionTypes.saved_later) && (
              <li>
                <Link
                  to="/save-for-later"
                  className={`d-flex align-items-center ${
                    pathname === '/save-for-later' ? 'active' : ''
                  }`}
                >
                  <span className="menu-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_941_8558)">
                        <path
                          d="M5.86758 17.3333H19.7342C20.0009 17.3333 20.2454 17.2222 20.4676 17C20.6898 16.7778 20.8009 16.5333 20.8009 16.2667V2.4C20.8009 2.13333 20.6898 1.88889 20.4676 1.66667C20.2454 1.44445 20.0009 1.33333 19.7342 1.33333H18.1342V9.13334L15.6676 7.66667L13.2009 9.13334V1.33333H5.86758C5.60091 1.33333 5.35647 1.44445 5.13424 1.66667C4.91202 1.88889 4.80091 2.13333 4.80091 2.4V16.2667C4.80091 16.5333 4.91202 16.7778 5.13424 17C5.35647 17.2222 5.60091 17.3333 5.86758 17.3333ZM5.86758 18.2667C5.2898 18.2667 4.81202 18.0778 4.43425 17.7C4.05647 17.3222 3.86758 16.8444 3.86758 16.2667V2.4C3.86758 1.82222 4.05647 1.34445 4.43425 0.966668C4.81202 0.58889 5.2898 0.400002 5.86758 0.400002H19.7342C20.312 0.400002 20.7898 0.58889 21.1676 0.966668C21.5454 1.34445 21.7342 1.82222 21.7342 2.4V16.2667C21.7342 16.8444 21.5454 17.3222 21.1676 17.7C20.7898 18.0778 20.312 18.2667 19.7342 18.2667H5.86758ZM2.26758 21.8667C1.6898 21.8667 1.21202 21.6778 0.834245 21.3C0.456467 20.9222 0.267578 20.4444 0.267578 19.8667V5.06667H1.20091V19.8667C1.20091 20.1333 1.31202 20.3778 1.53424 20.6C1.75647 20.8222 2.00091 20.9333 2.26758 20.9333H17.0676V21.8667H2.26758ZM5.86758 1.33333H4.80091H20.8009H5.86758Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_941_8558">
                          <rect width="22" height="22" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  {translate('sideMenu.savedSearch')}
                </Link>
              </li>
            )}
            {/* {hasRole(UserRoleTypes.high_order_request) && (
              <li>
                <Link to="/higher" className={`d-flex align-items-center ${pathname === '/higher' ? 'active' : ''}`}>
                  <i className="icon-order-request"></i>
                  {translate('sideMenu.highValue')}
                  Requests
                </Link>
              </li>
            )} */}
            {/* {hasRole(UserPermissionTypes.return_list) && (
              <li>
                <Link
                  to="/returns"
                  className={`d-flex align-items-center ${
                    pathname === '/returns' ? 'active' : ''
                  }`}
                >
                  <i className="icon-return"></i>
                  {translate('sideMenu.returnRequests')}
                </Link>
              </li>
            )} */}
            {/* {authState?.userType === UserType.Salesperson &&
              (hasRole(UserPermissionTypes.schedule_master_list) ||
                hasRole(UserPermissionTypes.schedule_list)) && (
                <li className={subMenu === subMenus.schedule ? 'active' : ''}>
                  <a
                    href="#"
                    className={`d-flex align-items-center  ${
                      pathname === RouteKeys.ScheduleManagement ||
                      pathname === RouteKeys.Schedules
                        ? 'active'
                        : ''
                    }`}
                    onClick={(e) => {
                      subMenuSelection(e, subMenus.schedule);
                      if (props.isExpand === false && subMenu !== null) {
                        toggleSubMenu(null);
                      }
                      if (props.isExpand === false) {
                        props.expandToggle();
                      }
                    }}
                  >
                    <i
                      className={`icon-schedule-management ${
                        subMenu === subMenus.schedule ? 'text-primary' : ''
                      }`}
                    ></i>
                    {translate('sideMenu.scheduleManagement')}{' '}
                    <span className="icon-arrow-down ml-auto font-xxs"></span>
                  </a>
                  {subMenu === subMenus.schedule && (
                    <ul className="submenu list-unstyled pb-2">
                      {hasRole(UserPermissionTypes.schedule_master_list) && (
                        <li>
                          <Link
                            to="/schedule-management"
                            className={`d-flex font-weight-normal py-2 font-xs ${
                              pathname === '/schedule-management'
                                ? 'active'
                                : ''
                            }`}
                          >
                            {translate('sideMenu.manageScheduleMasters')}
                          </Link>
                        </li>
                      )}
                      {hasRole(UserPermissionTypes.schedule_list) && (
                        <li>
                          <Link
                            to="/schedules"
                            className={`d-flex font-weight-normal py-2 font-xs ${
                              pathname === '/schedules' ? 'active' : ''
                            }`}
                          >
                            {translate('sideMenu.schedules')}
                          </Link>
                        </li>
                      )}
                      {hasRole(UserPermissionTypes.schedule_list) && (
                        <li>
                          <Link
                            to="/visitation-requests"
                            className={`\d-flex font-weight-normal py-2 font-xs ${
                              pathname === '/visitation-requests'
                                ? 'active'
                                : ''
                            }`}
                          >
                            {translate('sideMenu.newVisitationRequests')}
                          </Link>
                        </li>
                      )}
                    </ul>
                  )}
                </li>
              )} */}

            {/* {authState?.userType === UserType.Salesperson &&
              hasRole(UserPermissionTypes.customer_request_view) && (
                <li>
                  <Link
                    to="/customer-requests"
                    className={`d-flex align-items-center ${
                      pathname === '/customer-requests' ? 'active' : ''
                    }`}
                  >
                    <i className="icon-new-customer"></i>
                    {translate('sideMenu.newCustomerRequests')}
                  </Link>
                </li>
              )} */}
            {hasRole(UserPermissionTypes.view_duepayments) && (
              <li>
                <Link
                  to={
                    authState?.userType === UserType.Salesperson
                      ? RouteKeys.DueCustomers
                      : RouteKeys.DuePayments
                  }
                  className={`d-flex align-items-center ${
                    pathname === '/orders' ? 'active' : ''
                  }`}
                >
                  <span className="menu-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <path
                        d="M20.7078 15.1768C20.2481 14.0833 19.2748 13.7164 17.8073 14.0961C17.2239 14.246 16.5061 14.4709 15.7511 14.7079C14.9746 14.9521 14.1407 15.2096 13.3821 15.4074C13.3767 15.3779 13.382 15.3565 13.3749 15.3258C13.0929 14.1067 11.5954 12.4338 8.59152 12.813C6.77225 13.0446 6.29135 12.4682 5.82724 11.91C5.59473 11.6302 5.35431 11.3407 4.98303 11.1617C3.3821 10.3921 1.01648 11.3058 0.329594 11.6041C0.0546776 11.7239 -0.0717368 12.0439 0.0484769 12.3188C0.167831 12.5946 0.488731 12.7193 0.762788 12.6004C1.904 12.104 3.56771 11.6867 4.51096 12.1403C4.66919 12.2167 4.81946 12.3966 4.99186 12.6048C5.55232 13.2771 6.30905 14.2005 8.72943 13.8906C10.5275 13.6603 11.4522 14.3277 11.8429 14.7455C12.1709 15.0973 12.2964 15.4389 12.3282 15.6255C11.2383 15.9733 9.57369 16.3574 9.0459 16.2257C8.4766 16.0847 6.44429 15.5583 5.10673 15.2118C4.81239 15.1375 4.51978 15.3108 4.44465 15.6016C4.36951 15.892 4.54363 16.1882 4.83448 16.2637C6.17548 16.6112 8.21314 17.1385 8.78334 17.2799C8.93537 17.3179 9.11574 17.3343 9.31552 17.3343C10.2806 17.3343 11.6833 16.953 12.4093 16.7348C13.4478 16.5687 14.7831 16.1506 16.0773 15.7444C16.811 15.5136 17.5094 15.294 18.0778 15.1481C19.158 14.8718 19.5081 15.1278 19.7061 15.5976C19.8962 16.0485 19.9192 16.254 19.9165 16.3353C18.0804 17.4739 11.3964 19.9142 9.74776 19.9142C8.62329 19.9142 5.24464 19.0404 0.710557 17.5769C0.422379 17.4823 0.118269 17.6419 0.0263435 17.927C-0.0656271 18.2121 0.0908864 18.5183 0.376394 18.6103C3.14158 19.5032 8.0363 21.0007 9.74776 21.0007C11.6307 21.0007 18.6391 18.449 20.5654 17.2101C21.3496 16.7057 20.8668 15.5552 20.7078 15.1768Z"
                        fill="white"
                      />
                      <path
                        d="M14.5737 11.9491C15.4427 11.9491 16.2807 11.7666 17.064 11.4068C17.3363 11.2813 17.4556 10.959 17.3301 10.6863C17.2063 10.4136 16.8845 10.2956 16.6096 10.4194C15.9705 10.7138 15.2854 10.8627 14.5738 10.8627C11.8784 10.8627 9.6852 8.66996 9.6852 5.97461C9.6852 3.27926 11.8784 1.08645 14.5737 1.08645C17.2691 1.08645 19.4623 3.27922 19.4623 5.97456C19.4623 6.83425 19.236 7.67892 18.8081 8.41754C18.6579 8.67738 18.7471 9.00937 19.0061 9.15964C19.2678 9.31167 19.5984 9.22106 19.7487 8.96207C20.2721 8.05816 20.5478 7.02521 20.5478 5.97456C20.5478 2.68032 17.8684 0 14.5737 0C11.279 0 8.59961 2.68032 8.59961 5.97456C8.59961 9.26881 11.279 11.9491 14.5737 11.9491Z"
                        fill="white"
                      />
                      <path
                        d="M15.4247 4.32095C15.5317 4.60117 15.8473 4.74261 16.1249 4.63656C16.406 4.53047 16.5474 4.21708 16.4414 3.93642C16.1647 3.20622 15.4309 2.71518 14.615 2.71518C14.1208 2.71518 13.6329 2.90125 13.2748 3.22527C12.8876 3.57709 12.6746 4.05183 12.6746 4.56188C12.6746 5.13031 12.9698 5.92456 14.3763 6.47928C14.6813 6.59949 15.3903 6.92791 15.3903 7.38581C15.3903 7.58605 15.3027 7.77479 15.1454 7.91799C14.7281 8.299 13.9166 8.12973 13.7257 7.62669C13.6196 7.34689 13.3058 7.20635 13.0255 7.31109C12.7444 7.41718 12.603 7.73057 12.7091 8.01123C12.9858 8.74143 13.7195 9.23206 14.5355 9.23292C15.0296 9.23292 15.5176 9.04685 15.8756 8.72242C16.2628 8.37061 16.4758 7.89586 16.4758 7.38581C16.4758 6.81697 16.1806 6.02223 14.7741 5.46882C14.47 5.34861 13.7602 5.01974 13.7602 4.56183C13.7602 4.3616 13.8477 4.17286 14.005 4.02965C14.4232 3.65177 15.2338 3.81711 15.4247 4.32095Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  {translate('sideMenu.duePayments')}
                </Link>
              </li>
            )}

            {authState?.userType === UserType.Salesperson && (
              <li className={subMenu === subMenus.settings ? 'active' : ''}>
                <a
                  href=""
                  className={`d-flex align-items-center  ${
                    pathname === '/account-settings' ||
                    pathname === RouteKeys.ManageSalesPerson ||
                    pathname === '/change-password'
                      ? 'active'
                      : ''
                  }`}
                  onClick={(e) => {
                    subMenuSelection(e, subMenus.salespersonSettings);
                    if (props.isExpand === false) props.expandToggle();
                  }}
                >
                  <span className="menu-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M8.88 0C6.19 0 4 2.19 4 4.88C4 7.57 6.19 9.76 8.88 9.76C11.57 9.76 13.76 7.57 13.76 4.88C13.76 2.19 11.56 0 8.88 0ZM8.88 8.69C7.06 8.69 5.09 7.23 5.09 4.88C5.09 2.84 6.89 0.99 8.88 0.99C10.86 0.99 12.67 2.85 12.67 4.88C12.67 6.98 10.96 8.69 8.88 8.69Z"
                        fill="white"
                      />
                      <path
                        d="M4.38 12C1.96 12 0 13.96 0 16.38V20.38C0 20.59 0.17 20.76 0.38 20.76H8.22C8.31 20.76 8.74 20.74 8.74 20.28C8.74 19.92 8.58 19.77 8.22 19.77H1.12V16.38C1.12 14.17 2.76 13.01 4.37 13.01H10.37C10.56 13.01 10.75 12.71 10.75 12.49C10.75 12.28 10.57 12 10.37 12H4.38Z"
                        fill="white"
                      />
                      <path
                        d="M16.8802 19.8506C18.2402 19.8506 19.3502 18.7406 19.3502 17.3806C19.3502 16.0206 18.2402 14.9106 16.8802 14.9106C15.5202 14.9106 14.4102 16.0206 14.4102 17.3806C14.4102 18.7406 15.5102 19.8506 16.8802 19.8506ZM16.8802 15.8506C17.7202 15.8506 18.4102 16.5306 18.4102 17.3806C18.4102 18.2306 17.7302 18.9106 16.8802 18.9106C16.0302 18.9106 15.3502 18.2306 15.3502 17.3806C15.3502 16.5306 16.0302 15.8506 16.8802 15.8506Z"
                        fill="white"
                      />
                      <path
                        d="M21.5602 17.8906V17.8706C21.5802 17.7006 21.5902 17.5306 21.5902 17.3706C21.5902 17.2006 21.5802 17.0306 21.5602 16.8706V16.8506L22.6002 16.1006C23.0102 15.8106 23.1302 15.2606 22.8802 14.8206L22.0802 13.4406C21.8302 13.0106 21.2902 12.8306 20.8302 13.0406L19.6502 13.5706L19.6402 13.5606C19.3702 13.3606 19.0802 13.1906 18.7802 13.0606L18.6402 11.7706C18.5902 11.2706 18.1702 10.8906 17.6702 10.8906H16.0802C15.5802 10.8906 15.1602 11.2706 15.1102 11.7706L14.9802 13.0606L14.9702 13.0706C14.6702 13.2006 14.3802 13.3706 14.1102 13.5706L14.1002 13.5806L12.9202 13.0506C12.4602 12.8406 11.9302 13.0106 11.6702 13.4506L10.8702 14.8306C10.6202 15.2606 10.7402 15.8106 11.1502 16.1106L12.1902 16.8606V16.8706C12.1702 17.0406 12.1602 17.2106 12.1602 17.3706C12.1602 17.5406 12.1702 17.7106 12.1902 17.8706V17.8906L11.1502 18.6406C10.7402 18.9306 10.6202 19.4806 10.8702 19.9206L11.6702 21.3006C11.9202 21.7406 12.4502 21.9106 12.9102 21.7006L14.0902 21.1706L14.1002 21.1806C14.3702 21.3806 14.6602 21.5506 14.9602 21.6806L15.1002 22.9706C15.1502 23.4706 15.5702 23.8506 16.0702 23.8506H17.6602C18.1602 23.8506 18.5802 23.4706 18.6302 22.9706L18.7602 21.6806L18.7702 21.6706C19.0702 21.5406 19.3602 21.3706 19.6302 21.1706L19.6402 21.1606L20.8202 21.6906C21.2802 21.9006 21.8102 21.7306 22.0702 21.2906L22.8702 19.9106C23.1202 19.4806 23.0002 18.9306 22.5902 18.6306L21.5602 17.8906ZM12.9802 18.4906C13.1302 18.3806 13.2002 18.2006 13.1702 18.0206C13.1402 17.8306 13.1002 17.6006 13.1002 17.3706C13.1002 17.1306 13.1402 16.9106 13.1702 16.7206C13.2002 16.5406 13.1302 16.3606 12.9802 16.2506L11.6802 15.3206L12.5002 13.9006L13.9602 14.5606C14.1302 14.6406 14.3202 14.6106 14.4602 14.4906C14.8002 14.2006 15.1802 13.9806 15.5802 13.8406C15.7502 13.7806 15.8702 13.6206 15.8902 13.4406L16.0502 11.8506H17.6902L17.8502 13.4506C17.8702 13.6306 17.9902 13.7906 18.1602 13.8506C18.5602 14.0006 18.9402 14.2106 19.2802 14.5006C19.4202 14.6206 19.6102 14.6406 19.7802 14.5706L21.2502 13.9106L22.0702 15.3306L20.7702 16.2606C20.6202 16.3706 20.5502 16.5506 20.5802 16.7306C20.6102 16.9206 20.6502 17.1506 20.6502 17.3806C20.6502 17.6106 20.6102 17.8406 20.5802 18.0306C20.5502 18.2106 20.6302 18.3906 20.7702 18.5006L22.0702 19.4306L21.2502 20.8506L19.7902 20.1906C19.6302 20.1206 19.4302 20.1406 19.2902 20.2606C18.9502 20.5506 18.5702 20.7706 18.1702 20.9106C18.0002 20.9706 17.8802 21.1306 17.8602 21.3106L17.7002 22.9006H16.0602L15.9002 21.3106C15.8802 21.1306 15.7602 20.9706 15.5902 20.9106C15.1902 20.7606 14.8102 20.5406 14.4702 20.2606C14.3302 20.1406 14.1402 20.1206 13.9702 20.1906L12.5102 20.8506L11.6902 19.4306L12.9802 18.4906Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  {/* <i
                    className={`icon-account-settings ${
                      subMenu === subMenus.salespersonSettings
                        ? 'text-primary'
                        : ''
                    }`}
                  ></i> */}
                  {translate('sideMenu.accountSettings')}{' '}
                  <span className="icon-arrow-down ml-auto font-xxs"></span>
                </a>
                {subMenu === subMenus.salespersonSettings && (
                  <ul className="submenu list-unstyled pb-2">
                    {hasRole(
                      UserPermissionTypes.view_account_personal_info
                    ) && (
                      <li>
                        <Link
                          to="/account-settings"
                          className="d-flex font-weight-normal py-2 font-xs"
                        >
                          <i></i>
                          {translate('sideMenu.profileInformation')}
                        </Link>
                      </li>
                    )}

                    {/* {hasRole(UserPermissionTypes.list_salespersons) && (
                      <li>
                        <Link
                          to={RouteKeys.ManageSalesPerson}
                          className="d-flex font-weight-normal py-2 font-xs"
                        >
                          <i></i>
                          {translate('sideMenu.manageSalesPerson')}
                        </Link>
                      </li>
                    )} */}
                    <li>
                      <Link
                        to="/change-password"
                        className="d-flex font-weight-normal py-2 font-xs"
                      >
                        <i></i>
                        {translate('common.changePassword')}
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            )}

            {/* static report menu */}
            {hasRole(UserPermissionTypes.report) && (
              <li className={subMenu === subMenus.sales ? 'active' : ''}>
                <a
                  href="#"
                  className={`d-flex align-items-center  ${
                    pathname === RouteKeys.Sales ? 'active' : ''
                  }`}
                  onClick={(e) => {
                    subMenuSelection(e, subMenus.reports);
                    if (props.isExpand === false && subMenu !== null) {
                      toggleSubMenu(null);
                    }
                    if (props.isExpand === false) {
                      props.expandToggle();
                    }
                  }}
                >
                  <i className={`icon-reports`}></i>
                  {translate('reports.reports')}
                  <span className="icon-arrow-down ml-auto font-xxs"></span>
                </a>
                {subMenu === subMenus.reports && (
                  <ul className="submenu list-unstyled pb-2">
                    {hasRole(UserPermissionTypes.report_sales) && (
                      <li>
                        <Link
                          to="/sales"
                          className={`\d-flex font-weight-normal py-2 font-xs ${
                            pathname === '/sales' ? 'active' : ''
                          }`}
                        >
                          <i></i>
                          {translate('reports.sales')}
                        </Link>
                      </li>
                    )}
                    {hasRole(UserPermissionTypes.report_payment) && (
                      <li>
                        <Link
                          to="/reports-payment"
                          className={`\d-flex font-weight-normal py-2 font-xs ${
                            pathname === '/reports-payment' ? 'active' : ''
                          }`}
                        >
                          <i></i>
                          {translate('duePayments.payment')}
                        </Link>
                      </li>
                    )}
                    {hasRole(UserPermissionTypes.report_customer) && (
                      <li>
                        <Link
                          to="/reports-customers"
                          className={`\d-flex font-weight-normal py-2 font-xs ${
                            pathname === '/reports-customers' ? 'active' : ''
                          }`}
                        >
                          <i></i>
                          {translate('reports.customers')}
                        </Link>
                      </li>
                    )}
                    {/* {hasRole(UserPermissionTypes.report_salesperson) && (
                      <li>
                        <Link
                          to="/sales-person-report"
                          className={`\d-flex font-weight-normal py-2 font-xs ${
                            pathname === '/sales-person-report' ? 'active' : ''
                          }`}
                        >
                          <i></i>
                          {translate('salesPerson.salesPerson')}
                        </Link>
                      </li>
                    )} */}
                  </ul>
                )}
              </li>
            )}
            {/* static report menu */}

            {authState.userType !== 'Salesperson' && (
              <li className={subMenu === subMenus.settings ? 'active' : ''}>
                <a
                  href=""
                  className={`d-flex align-items-center  ${
                    pathname === RouteKeys.StaffPersonalInfo ||
                    pathname === '/general-settings' ||
                    pathname === '/staff-member' ||
                    pathname === '/change-password' ||
                    pathname === '/terms-of-use'
                      ? 'active'
                      : ''
                  }`}
                  onClick={(e) => {
                    subMenuSelection(e, subMenus.settings);
                    if (props.isExpand === false) props.expandToggle();
                  }}
                >
                  <span className="menu-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M8.88 0C6.19 0 4 2.19 4 4.88C4 7.57 6.19 9.76 8.88 9.76C11.57 9.76 13.76 7.57 13.76 4.88C13.76 2.19 11.56 0 8.88 0ZM8.88 8.69C7.06 8.69 5.09 7.23 5.09 4.88C5.09 2.84 6.89 0.99 8.88 0.99C10.86 0.99 12.67 2.85 12.67 4.88C12.67 6.98 10.96 8.69 8.88 8.69Z"
                        fill="white"
                      />
                      <path
                        d="M4.38 12C1.96 12 0 13.96 0 16.38V20.38C0 20.59 0.17 20.76 0.38 20.76H8.22C8.31 20.76 8.74 20.74 8.74 20.28C8.74 19.92 8.58 19.77 8.22 19.77H1.12V16.38C1.12 14.17 2.76 13.01 4.37 13.01H10.37C10.56 13.01 10.75 12.71 10.75 12.49C10.75 12.28 10.57 12 10.37 12H4.38Z"
                        fill="white"
                      />
                      <path
                        d="M16.8802 19.8506C18.2402 19.8506 19.3502 18.7406 19.3502 17.3806C19.3502 16.0206 18.2402 14.9106 16.8802 14.9106C15.5202 14.9106 14.4102 16.0206 14.4102 17.3806C14.4102 18.7406 15.5102 19.8506 16.8802 19.8506ZM16.8802 15.8506C17.7202 15.8506 18.4102 16.5306 18.4102 17.3806C18.4102 18.2306 17.7302 18.9106 16.8802 18.9106C16.0302 18.9106 15.3502 18.2306 15.3502 17.3806C15.3502 16.5306 16.0302 15.8506 16.8802 15.8506Z"
                        fill="white"
                      />
                      <path
                        d="M21.5602 17.8906V17.8706C21.5802 17.7006 21.5902 17.5306 21.5902 17.3706C21.5902 17.2006 21.5802 17.0306 21.5602 16.8706V16.8506L22.6002 16.1006C23.0102 15.8106 23.1302 15.2606 22.8802 14.8206L22.0802 13.4406C21.8302 13.0106 21.2902 12.8306 20.8302 13.0406L19.6502 13.5706L19.6402 13.5606C19.3702 13.3606 19.0802 13.1906 18.7802 13.0606L18.6402 11.7706C18.5902 11.2706 18.1702 10.8906 17.6702 10.8906H16.0802C15.5802 10.8906 15.1602 11.2706 15.1102 11.7706L14.9802 13.0606L14.9702 13.0706C14.6702 13.2006 14.3802 13.3706 14.1102 13.5706L14.1002 13.5806L12.9202 13.0506C12.4602 12.8406 11.9302 13.0106 11.6702 13.4506L10.8702 14.8306C10.6202 15.2606 10.7402 15.8106 11.1502 16.1106L12.1902 16.8606V16.8706C12.1702 17.0406 12.1602 17.2106 12.1602 17.3706C12.1602 17.5406 12.1702 17.7106 12.1902 17.8706V17.8906L11.1502 18.6406C10.7402 18.9306 10.6202 19.4806 10.8702 19.9206L11.6702 21.3006C11.9202 21.7406 12.4502 21.9106 12.9102 21.7006L14.0902 21.1706L14.1002 21.1806C14.3702 21.3806 14.6602 21.5506 14.9602 21.6806L15.1002 22.9706C15.1502 23.4706 15.5702 23.8506 16.0702 23.8506H17.6602C18.1602 23.8506 18.5802 23.4706 18.6302 22.9706L18.7602 21.6806L18.7702 21.6706C19.0702 21.5406 19.3602 21.3706 19.6302 21.1706L19.6402 21.1606L20.8202 21.6906C21.2802 21.9006 21.8102 21.7306 22.0702 21.2906L22.8702 19.9106C23.1202 19.4806 23.0002 18.9306 22.5902 18.6306L21.5602 17.8906ZM12.9802 18.4906C13.1302 18.3806 13.2002 18.2006 13.1702 18.0206C13.1402 17.8306 13.1002 17.6006 13.1002 17.3706C13.1002 17.1306 13.1402 16.9106 13.1702 16.7206C13.2002 16.5406 13.1302 16.3606 12.9802 16.2506L11.6802 15.3206L12.5002 13.9006L13.9602 14.5606C14.1302 14.6406 14.3202 14.6106 14.4602 14.4906C14.8002 14.2006 15.1802 13.9806 15.5802 13.8406C15.7502 13.7806 15.8702 13.6206 15.8902 13.4406L16.0502 11.8506H17.6902L17.8502 13.4506C17.8702 13.6306 17.9902 13.7906 18.1602 13.8506C18.5602 14.0006 18.9402 14.2106 19.2802 14.5006C19.4202 14.6206 19.6102 14.6406 19.7802 14.5706L21.2502 13.9106L22.0702 15.3306L20.7702 16.2606C20.6202 16.3706 20.5502 16.5506 20.5802 16.7306C20.6102 16.9206 20.6502 17.1506 20.6502 17.3806C20.6502 17.6106 20.6102 17.8406 20.5802 18.0306C20.5502 18.2106 20.6302 18.3906 20.7702 18.5006L22.0702 19.4306L21.2502 20.8506L19.7902 20.1906C19.6302 20.1206 19.4302 20.1406 19.2902 20.2606C18.9502 20.5506 18.5702 20.7706 18.1702 20.9106C18.0002 20.9706 17.8802 21.1306 17.8602 21.3106L17.7002 22.9006H16.0602L15.9002 21.3106C15.8802 21.1306 15.7602 20.9706 15.5902 20.9106C15.1902 20.7606 14.8102 20.5406 14.4702 20.2606C14.3302 20.1406 14.1402 20.1206 13.9702 20.1906L12.5102 20.8506L11.6902 19.4306L12.9802 18.4906Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  {/* <i
                    className={`icon-account-settings ${
                      subMenu === subMenus.settings ? 'text-primary' : ''
                    }`}
                  ></i> */}
                  {translate('sideMenu.accountSettings')}{' '}
                  <span className="icon-arrow-down ml-auto font-xxs"></span>
                </a>
                {subMenu === subMenus.settings && (
                  <ul className="submenu list-unstyled pb-2">
                    {authState.userType === UserType.User && (
                      <li>
                        <Link
                          to={RouteKeys.StaffPersonalInfo}
                          className="d-flex font-weight-normal py-2 font-xs"
                        >
                          <i></i>
                          {translate('sideMenu.profileInformation')}
                        </Link>
                      </li>
                    )}
                    {hasRole(UserPermissionTypes.view_account_general_info) &&
                      authState.userType !== UserType.User && (
                        <li>
                          <Link
                            to="/general-settings"
                            className="d-flex font-weight-normal py-2 font-xs"
                          >
                            <i></i>
                            {translate('sideMenu.generalSettings')}
                          </Link>
                        </li>
                      )}

                    {hasRole(UserPermissionTypes.staff_list) &&
                      authState.userType === UserType.Customer && (
                        <li>
                          <Link
                            to="/staff-member"
                            className="d-flex font-weight-normal py-2 font-xs"
                          >
                            <i></i>
                            {translate('sideMenu.staff')}
                          </Link>
                        </li>
                      )}
                    <li>
                      <Link
                        to="/change-password"
                        className="d-flex font-weight-normal py-2 font-xs"
                      >
                        <i></i>
                        {translate('common.changePassword')}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/terms-of-use"
                        className="d-flex font-weight-normal py-2 font-xs"
                      >
                        <i></i>
                        {translate('sideMenu.termsOfUse')}
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
            )}
            <li>
              <Link
                to="/faq"
                className={`d-flex align-items-center ${
                  pathname === '/faq' ? 'active' : ''
                }`}
              >
                <i className="icon-faq sm"></i>
                {translate('sideMenu.faq')}
              </Link>
            </li>
            <li>
              <a
                href="#"
                className="d-flex align-items-center"
                onClick={() => {
                  handleLogout();
                }}
              >
                <i className="icon-logout sm"></i>
                {translate('sideMenu.logOut')}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default SideMenu;
